export const GET_REPORT = 'GET_REPORT';
export const SET_REPORT = 'SET_REPORT';
export const ERROR_REPORT = 'ERROR_REPORT';
export const GET_REPORT_ID = 'GET_REPORT_ID';